module.exports = __webpack_public_path__ + "static/media/bottom_sheet_icon_mobile.9af049b2.svg";